export const B2B_PORTAL_URL = process.env.NEXT_PUBLIC_BUSINESS_BASE_URL;
export const WEBSITE_URL = process.env.NEXT_PUBLIC_BASE_URL;
export const B2C_API_BASE_URL = process.env.NEXT_PUBLIC_APP_API_URL;
export const WHITE_LABEL_URL = process.env.NEXT_PUBLIC_WHITE_LABEL_URL;
export const ENVIRONMENT = process.env.NEXT_PUBLIC_ENVIRONMENT;
export const IS_DEVELOPMENT = ENVIRONMENT === "development";
export const IS_PRODUCTION = ENVIRONMENT === "production";
export const API_APPLICATION_ID = process.env.NEXT_PUBLIC_API_APPLICATION_ID;
export const SECRET_KEY = process.env.NEXT_PUBLIC_API_SECRET_KEY;
export const B2B_API_BASE_URL = process.env.NEXT_PUBLIC_APP_B2B_API_URL;
export const BLOG_API_BASE_URL = process.env.NEXT_PUBLIC_BLOG_API_URL;
export const MIXPANEL_PROJECT_TOKEN =
  process.env.NEXT_PUBLIC_MIXPANEL_PROJECT_TOKEN;
export const SENTRY_AUTH_TOKEN = process.env.NEXT_PUBLIC_SENTRY_AUTH_TOKEN;
export const SENTRY_PROJECT = process.env.NEXT_PUBLIC_SENTRY_PROJECT;
export const SENTRY_ORG = process.env.NEXT_PUBLIC_SENTRY_ORG;
export const SENTRY_URL = process.env.NEXT_PUBLIC_SENTRY_URL;
export const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN;
